import { render, staticRenderFns } from "./AgentSilver.vue?vue&type=template&id=0a5331ea&scoped=true&lang=pug&"
import script from "./AgentSilver.vue?vue&type=script&lang=js&"
export * from "./AgentSilver.vue?vue&type=script&lang=js&"
import style0 from "./AgentSilver.vue?vue&type=style&index=0&id=0a5331ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5331ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5331ea')) {
      api.createRecord('0a5331ea', component.options)
    } else {
      api.reload('0a5331ea', component.options)
    }
    module.hot.accept("./AgentSilver.vue?vue&type=template&id=0a5331ea&scoped=true&lang=pug&", function () {
      api.rerender('0a5331ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/silver/AgentSilver.vue"
export default component.exports